// extracted by mini-css-extract-plugin
export default {"container":"src-components-Modules-revamp-BlockWrapper-css-module__container--m88qE","innerContainer":"src-components-Modules-revamp-BlockWrapper-css-module__innerContainer--B4RZ-"};